import { Component, OnInit } from "@angular/core";
import {BusinessService} from "../../services/business/business.service";
import {Router} from "@angular/router";

declare interface RouteInfo {
  path?: string;
  title: string;
  icon: string;
  class: string;
  expanded?: boolean;
  children?: ChildRouteInfo[];
}
declare interface ChildRouteInfo {
  path: string;
  title: string;
  class?: string;
}

export const ROUTES: RouteInfo[] = [
  {
    path: "/dashboard",
    title: "component.sidebar.list.dashboard",
    icon: "icon-chart-pie-36",
    class: ""
  },
  {
    path: "/menu",
    title: "component.sidebar.list.menu",
    icon: "icon-paper",
    class: ""
  },
  /*{
    path: "/dashboard-old",
    title: "Dashboard Old",
    icon: "icon-chart-pie-36",
    class: ""
  },*/
  {
    path: "/preferences",
    title: "component.sidebar.list.preferences",
    icon: "icon-palette",
    class: ""
  },
  /*{
    path: "/maps",
    title: "Maps",
    icon: "icon-pin",
    class: "" },
  {
    path: "/notifications",
    title: "Notifications",
    icon: "icon-bell-55",
    class: ""
  },*/
  {
    title: "component.sidebar.list.payment",
    icon: "icon-money-coins",
    class: "",
    expanded: false,
    children: [
      {
        path: "/payment/order-history",
        title: "component.sidebar.list.orderHistory"
      },
      {
        path: "/payment/bank-account",
        title: "component.sidebar.list.bankAccount"
      }
    ]
  },
  {
    path: "/user/business-details",
    title: "component.sidebar.list.businessProfile",
    icon: "icon-badge",
    class: ""
  },
  /*{
    path: "/tables",
    title: "Table List",
    icon: "icon-puzzle-10",
    class: ""
  },
  {
    path: "/typography",
    title: "Typography",
    icon: "icon-align-center",
    class: ""
  }*/
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit {
  menuItems: RouteInfo[];

  constructor(private businessService: BusinessService,
              private router: Router) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  onMenuItemClick(menuItem: RouteInfo) {
    if (menuItem.children) {
      menuItem.expanded = !menuItem.expanded;
    }
  }
}
